import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  connect() {
    if (window.isOnline == undefined) window.isOnline = true
    this.consumer = createConsumer()
    this.setupConnectionTracking()
    this.updateUI()
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }

    if (this.consumer) {
      this.consumer.disconnect()
    }

    if (this.connectionCheckInterval) {
      clearInterval(this.connectionCheckInterval)
    }
  }

  setupConnectionTracking() {
    // Create a dummy subscription to establish ActionCable connection
    this.subscription = this.consumer.subscriptions.create("ConnectionStatusChannel", {
      connected() {
        console.log("ActionCable: Connected to ConnectionStatusChannel")
      },

      disconnected() {
        console.log("ActionCable: Disconnected from ConnectionStatusChannel")
      },

      received() {
        // We don't expect to receive any data, this is just for connection status
      }
    })

    // Simple polling approach - check ActionCable connection state
    this.connectionCheckInterval = setInterval(() => {
      const isConnected = this.consumer.connection.isOpen()
      const wasOnline = window.isOnline

      // Only change status if it's actually different
      if (isConnected !== wasOnline) {
        console.log(`ActionCable: Connection state changed from ${wasOnline ? 'online' : 'offline'} to ${isConnected ? 'online' : 'offline'}`)
        this.setOnlineStatus(isConnected)
      }
    }, 3000) // Check every 3 seconds
  }

  setOnlineStatus(isOnline) {
    if (window.isOnline !== isOnline) {
      window.isOnline = isOnline
      this.updateUI()
    }
  }

  updateUI() {
    if (window.isOnline) {
      this.element.removeAttribute('data-offline')
      this.element.classList.remove('offline')
    } else {
      this.element.setAttribute('data-offline', 'true')
      this.element.classList.add('offline')
    }
  }
}